import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = 'https://app.recensement-enfantsnonproteges.fr';

export default function ComingSoon({ onClose }) {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(API + '/api/newsletter', { email });
      setSent(true);
    } catch(e) { setSent(true); }
    setLoading(false);
  };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.75)', zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '16px'
    }}>
      <div style={{
        background: '#fff', borderRadius: '16px', maxWidth: '480px', width: '100%',
        padding: '40px 36px', position: 'relative', textAlign: 'center'
      }}>
        <div style={{fontSize:'11px',letterSpacing:'0.1em',textTransform:'uppercase',color:'#999',marginBottom:'12px'}}>
          Recensement national
        </div>
        <h2 style={{fontSize:'22px',fontWeight:'700',lineHeight:'1.25',marginBottom:'12px',color:'#1a1a1a'}}>
          Le site ouvre le <span style={{color:'#dc2626'}}>10 juillet 2026</span>
        </h2>
        <p style={{fontSize:'14px',color:'#555',lineHeight:'1.65',marginBottom:'24px'}}>
          Ce recensement documentera les situations d'enfants victimes de violences dont la protection n'a pas été assurée par la justice française. Laissez votre email pour être informé·e du lancement.
        </p>

        {sent ? (
          <div style={{background:'#f0fdf4',border:'1px solid #86efac',borderRadius:'8px',padding:'14px',color:'#15803d',fontSize:'14px',fontWeight:'500'}}>
            ✓ Vous serez informé·e dès l'ouverture du 10 juillet.
          </div>
        ) : (
          <div style={{display:'flex',gap:'8px',flexWrap:'wrap'}}>
            <input
              type="email"
              placeholder="Votre email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && submit()}
              style={{flex:1,fontSize:'13px',border:'1px solid #d0cec9',borderRadius:'8px',padding:'10px 14px',minWidth:'200px'}}
            />
            <button
              onClick={submit}
              disabled={loading || !email}
              style={{background:'#dc2626',color:'#fff',border:'none',borderRadius:'8px',padding:'10px 20px',fontSize:'13px',fontWeight:'600',cursor:'pointer',opacity:email?1:0.5}}
            >
              {loading ? '…' : 'Me notifier'}
            </button>
          </div>
        )}

        <div style={{marginTop:'20px',fontSize:'11px',color:'#bbb'}}>
          Votre email ne sera utilisé que pour vous notifier de l'ouverture du site.
        </div>

        <button
          onClick={onClose}
          style={{position:'absolute',top:'16px',right:'16px',background:'transparent',border:'none',fontSize:'20px',color:'#ccc',cursor:'pointer',lineHeight:1}}
        >✕</button>
      </div>
    </div>
  );
}
